export default class CommonAbstractServices {
  static getRefreshCookie() {
    logger.error(`Common:: getRefreshCookie() not implemented`);
  }

  static getNavigationAndMemberDetails() {
    logger.error(`Common:: getNavigationAndMemberDetails() not implemented`);
  }

  static getSearchPrediction() {
    logger.error(`Common:: getSearchPrediction() not implemented`);
  }

  static getSearchResults() {
    logger.error(`Common:: getSearchResults() not implemented`);
  }

  static raiseWorkItem() {
    logger.error(`Common:: raiseWorkItem() not implemented`);
  }

}
